// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>

import GlobalStyles from '../../../../config/styles';

const styles = theme => ({
  container: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'column',
  },
  text1: {
    marginTop: 35,
    marginBottom: 0,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE,
    color: GlobalStyles.color.COLOR_GREY,
    textAlign: 'center',
    width: 380,
    [theme.breakpoints.down(400)]: {
      width: '95%',
    },
  },
  text2: {
    marginTop: 24,
    marginBottom: 24,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    width: 380,
    [theme.breakpoints.down(400)]: {
      width: '95%',
    },
  },
  helperText: {
    color: GlobalStyles.color.COLOR_GREY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    width: 380,
    [theme.breakpoints.down(400)]: {
      width: '95%',
    },
  },
  button: {
    marginTop: 30,
    width: 200,
  },
  buttonWithError: {
    marginTop: 10,
    width: 200,
  },
  error: {
    margin: 15,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    color: GlobalStyles.color.COLOR_REJECT,
  },
});

export default styles;
